<app-container
	[title]="'Condo Corporation & Management'"
	class="flex flex-col flex-1 mr-4 h-full overflow-y-auto"
>
	<div class="flex flex-col gap-4">
		<app-sale-condo-corp-search-card />

		<ng-container *ngIf="condoCorp$ | async">
			<app-sale-condo-management-type
				labelOrientation="row"
				*ngIf="!(management$ | async)"
			/>
			<app-sale-condo-mgmt-search-card
				*ngIf="
					(managementType$ | async) === 'management-company' ||
					(management$ | async)
				"
			/>

			<div
				*ngIf="
					(management$ | async) || (managementType$ | async) === 'self-managed'
				"
			>
				<h4>Attention</h4>
				<div class="flex justify-between mt-2">
					<app-radio-group
						[labelIcon]="AI_GENERATED_ICON.icon"
						[labelIconClasses]="AI_GENERATED_ICON.classes"
						[labelToolTip]="attentionTypeAiTooltip$ | async"
						label="Attention type"
						[items]="attentionOptions"
						type="compact"
						[ngModel]="attentionType$ | async"
						(ngModelChange)="selectAttentionOption($event)"
					/>
					<app-input
						*ngIf="(attentionType$ | async) === 'Department'"
						label="Attention"
						class="ml-4"
						placeholder="Department name"
						[ngModel]="departmentName$ | async"
						(debounce)="setDepartmentName(departmentName)"
					/>
				</div>

				<app-member-card
					class="mt-4"
					*ngIf="
						(attentionType$ | async) === 'Person' && attentionContact$
							| async as attentionContact
					"
					[firstName]="attentionContact?.firstName"
					[lastName]="attentionContact?.lastName"
					[email]="attentionContact?.email"
					[phone]="attentionContact?.phoneNumber"
					member="Contact"
					(dropdown)="contactDropdownOptionSelect($event)"
				/>
			</div>
		</ng-container>
	</div>
</app-container>

<div class="flex-1 w-full ml-4 fees-panel">
	<app-container title="Status Certificate Fees" class="mb-5">
		<p>Enter details about the status certificate fee amount</p>
		<hr class="mt-2" />

		<app-container type="dark" class="mt-4">
			<app-input
				label="Base fee amount"
				orientation="row"
				[startIcon]="ICON.DOLLAR"
				class="mt-4"
				type="cents"
				[ngModel]="baseFee$ | async"
				(debounce)="setBaseFee($event)"
			/>
			<app-input
				label="Urgency fees"
				orientation="row"
				[startIcon]="ICON.DOLLAR"
				class="mt-4"
				type="cents"
				[ngModel]="urgencyFee$ | async"
				(debounce)="setUrgencyFee($event)"
			/>
		</app-container>

		<div class="flex justify-between mt-4">
			<span>Total fee</span>
			<span class="font-bold">
				{{ totalFee$ | async | centsToDollars }}
			</span>
		</div>
	</app-container>

	<app-container
		title="Add Status Certificate"
		*ngIf="isRefinanceOrPurchase$ | async"
		data-intercom-target="add-status-certificate"
	>
		<p>Add the condo status certificate details into your matter below</p>
		<hr class="mt-2" />

		<app-sale-file-upload
			*ngIf="!(statusCertificate$ | async)"
			type="dropzone"
			[saleId]="matterId$ | async"
			class="justify-self-center self-center w-full"
			documentName="Status Certificate"
			[documentType]="MatterDocumentType.STATUS_CERTIFICATE"
		/>

		<div *ngIf="statusCertificate$ | async as statusCertificate">
			<p class="text-lg py-4">Condo Status Certificate</p>
			<ui-card
				class="[&>button]:hover:bg-gray-50 [&>button]:duration-300"
				(click)="viewStatusCertificate(statusCertificate)"
			>
				<button card-content>
					<div class="flex gap-4">
						<div
							class="w-9 h-9 bg-blue-100 rounded-full flex items-center justify-center"
						>
							<i-tabler name="file-text" class="text-blue-600 w-4 h-4" />
						</div>
						<div class="space-y-1 flex flex-col items-start">
							<h6 class="h6 mb-0">{{ statusCertificate.name }}</h6>
							<p class="p-xs">
								Uploaded, {{ statusCertificate.uploadedAt | closerDate }}
							</p>
						</div>
					</div>
				</button>
			</ui-card>
		</div>
	</app-container>
</div>
